import React from "react";

import { ChevronDown } from "@useblu/ocean-icons-react";
import { AccordionTitleContent } from "./styles";

interface IProps {
  title: string;
  open: boolean;
  toggleAccordion: (params: boolean) => any;
}
export default function AccordionTitle({
  title,
  open,
  toggleAccordion,
}: IProps): JSX.Element {
  return (
    <AccordionTitleContent
      isOpen={open}
      onClick={() => toggleAccordion(!open)}
      role="button"
    >
      <p>{title}</p>
      <ChevronDown
        className="custom-chevron"
        size={20}
        style={{ minWidth: "20px" }}
      />
    </AccordionTitleContent>
  );
}
